import React from 'react';
import NavBar from "../../components/Navigation/NavBar";
import Footer from './LandingPage/Footer';
import { useMediaQuery } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import WhatAppMobile from './LandingPage/WhatAppMobile';


function AboutUs() {
    const isXs = useMediaQuery('(min-width:600px) and (max-width:3000px)');

    return (<>
        <NavBar />
<WhatAppMobile/>

        <div style={{ backgroundColor: '#CB8B65', display: 'flex', alignItems: 'center', paddingLeft: isXs ? '6rem' : '1rem', gap: '10px', height: '50px' }}>
            <div><a style={{ color: 'white', textDecoration: 'none', fontSize: '1rem' }} href="/">Home</a></div><ArrowForwardIosIcon style={{ fontSize: '14px', color: 'white' }} />
            <div style={{ fontSize: '1rem ', color: 'white' }}>About Us</div></div>

            <h1 style={{textAlign:'center', marginTop:'40px' }}>About Us</h1>

        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '50px 50px 200px 50px' }}>
            {/* Header Section */}
            <header style={{ textAlign: 'left', marginBottom: '40px' }}>
                <h2 style={{ fontSize: '24px',  color: '#C68863', fontWeight:'600', lineHeight:'35px' }}>Welcome to Kanha Home Tuitions</h2>
                <hr className='hr-tagg' style={{width:'80px', height:'5px', borderRadius:'10px', margin:'0px'}} />
                <p style={{ fontSize: '16px', marginTop: '15px' }}>
                    At Kanha Home Tuitions, we believe that education is not just about books — it's about building confidence, encouraging curiosity, and helping every student discover their true potential.
                    We’re more than just tutors — we’re mentors, guides, and a reliable support system for students who want to grow academically and personally.
                </p>
                <p style={{ fontSize: '16px', marginTop: '8px', lineHeight: '1.6' }}>
                    Whether your child needs help catching up, staying ahead, or preparing for competitive exams, we’re here to make learning simple, fun, and effective.
                </p>
            </header>

            {/* Our Story Section */}
            <section style={{ marginBottom: '20px' }}>
                <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#C68863',lineHeight:'35px' }}> Our Story: The Heart Behind Kanha Home Tuitions</h2>
                <hr className='hr-tagg' style={{width:'80px', height:'5px', borderRadius:'10px', margin:'0px'}} />
                <p style={{ fontSize: '16px', color: '#4b5563', lineHeight: '1.6'  , marginTop: '15px' }}>
                    Kanha Home Tuitions was born out of the passion, dedication and well qualified team.All team member  a well-respected educator with over 10 years of experience in teaching students of IIT-JEE, BITSAT, Olympiads, and Classes 11th & 12th. Today, our services are proudly available all over India, helping students across the country achieve academic excellence.
                </p>
                <p style={{ fontSize: '16px', color: '#4b5563', marginTop: '16px', lineHeight: '1.6' }}>
                    Having worked closely with students for over a decade, Dr. P.K. noticed one thing — every student is different. Some learn fast, some take time, and some just need a little extra push. That’s when the idea of personalized, one-on-one learning support came to life.
                </p>
                <p style={{ fontSize: '16px', color: '#4b5563', marginTop: '16px', lineHeight: '1.6' }}>
                    With a vision to help every child get the individual attention they deserve, Kanha Home Tuitions was founded — where learning is tailored, thoughtful, and results-driven.
                </p>
            </section>

            {/* Our Journey Section */}
            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#C68863',lineHeight:'35px' }}>Our Journey: From a Dream to Reality</h2>
                <hr className='hr-tagg' style={{width:'80px', height:'5px', borderRadius:'10px', margin:'0px'}} />
                <p style={{ fontSize: '16px', color: '#4b5563', lineHeight: '1.6', marginTop: '15px'  }}>
                    We started our journey in 2020, offering tutoring services to a handful of students. With word of mouth, positive results, and happy parents, our student base grew steadily.
                </p>
                <p style={{ fontSize: '16px', color: '#4b5563', marginTop: '16px', lineHeight: '1.6' }}>
                    In 2024, after years of hard work, love, and commitment, we proudly registered Kanha Home Tuitions as a trusted education provider. Today, we continue to grow — teaching thousands of students, expanding our team of skilled tutors, and building a name known for quality and care.
                </p>
            </section>

            {/* Our Values Section */}
            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#C68863',lineHeight:'35px' }}>Our Values: What We Believe In</h2>
                <hr className='hr-tagg' style={{width:'80px', height:'5px', borderRadius:'10px', margin:'0px'}} />

                <p style={{ fontSize: '16px', color: '#4b5563', lineHeight: '1.6', marginTop: '15px'  }}>
                    At Kanha Home Tuitions, we live by a few simple yet powerful principles:
                </p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '30px', fontSize: '16px', color: '#4b5563', marginTop: '16px', lineHeight: '1.6' }}>
                    <li><strong> Excellence</strong>– We aim to deliver the best in education, every single day.</li>
                    <li style={{ marginTop: '8px' }}><strong> Personalized Attention</strong> – Every student matters. We focus on their unique learning style.</li>
                    <li style={{ marginTop: '8px' }}><strong>Continuous Growth</strong> – We never stop learning and improving — just like our students.</li>
                    <li style={{ marginTop: '8px' }}><strong>Trust & Relationships</strong> – We build meaningful bonds with students and their families.</li>
                </ul>
                <p style={{ fontSize: '16px', color: '#4b5563', marginTop: '16px', lineHeight: '1.6' }}>
                    We don’t just help with homework — we help students build study habits, manage time, and become confident learners.
                </p>
            </section>

            {/* Our Mission Section */}
            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#C68863',lineHeight:'35px' }}>Our Mission: Lighting the Path to a Brighter Future</h2>
                <hr className='hr-tagg' style={{width:'80px', height:'5px', borderRadius:'10px', margin:'0px'}} />

                <p style={{ fontSize: '16px', color: '#4b5563', lineHeight: '1.6' , marginTop: '15px' }}>
                    Our mission is to make high-quality education accessible and personal. We aim to:
                </p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '30px', fontSize: '16px', color: '#4b5563', marginTop: '16px', lineHeight: '1.6' }}>
                    <li>Help students understand, not just memorize</li>
                    <li style={{ marginTop: '8px' }}>Boost confidence in every subject</li>
                    <li style={{ marginTop: '8px' }}>Improve academic performance through regular support</li>
                    <li style={{ marginTop: '8px' }}>Build a positive and stress-free learning environment</li>
                </ul>
                <p style={{ fontSize: '16px', color: '#4b5563', marginTop: '16px', lineHeight: '1.6' }}>
                    We want every student to say, “I can do it!”, and believe it too.
                </p>
            </section>

            {/* Why Choose Us Section */}
            <section style={{ marginBottom: '20px' }}>
                <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#C68863' ,lineHeight:'35px' }}> Why Choose Us?</h2>
                <hr className='hr-tagg' style={{width:'80px', height:'5px', borderRadius:'10px', margin:'0px'}} />

                <ul style={{ listStyleType: 'disc', paddingLeft: '30px', fontSize: '16px', color: '#4b5563', lineHeight: '1.6', marginTop: '15px'  }}>
                    <li><strong> Experienced Tutors</strong> who understand how to make concepts simple and clear.</li>
                    <li style={{ marginTop: '8px' }}><strong> One-on-One Attention</strong> to focus on each child’s strengths and weaknesses.</li>
                    <li style={{ marginTop: '8px' }}><strong> Flexible Timings</strong> – We work around your schedule.</li>
                    <li style={{ marginTop: '8px' }}><strong> Customized Study Plans</strong> – Tailored to each student’s needs.</li>
                    <li style={{ marginTop: '8px' }}><strong> Supportive Environment</strong> – We motivate, encourage, and celebrate progress.</li>
                </ul>
                <p style={{ fontSize: '16px', color: '#4b5563', marginTop: '16px', lineHeight: '1.6' }}>
                    Whether it’s school exams, board preparation, or overall academic improvement — we’re here to support every step of the way.
                </p>
            </section>


            <div
      style={{
        textAlign: 'left',
        lineHeight: '1.6',
        color: '#333',
      }}
    >
      <h2
      style={{ fontSize: '24px', fontWeight: '600', color: '#C68863', marginBottom: '5px' ,lineHeight:'35px'}}
      >
        Our Services
      </h2>
      <hr className='hr-tagg' style={{width:'80px', height:'5px', borderRadius:'10px', margin:'0px'}} />

      <p style={{fontSize:'16px', marginTop:'15px' }}>
        We provide qualified Personal Tutors for Home & Online Tuitions for:
      </p>

      <div style={{fontSize:'18px', fontWeight:'500', marginTop:'10px', marginBottom:'15px', paddingLeft:'15px'}}>
        Competitive Exams :
      </div>
      <ul style={{ listStyleType: 'disc', marginLeft: '15px', marginBottom: '15px' }}>
        <li>IIT-JEE (Main & Adv.)</li>
        <li>NEET</li>
        <li>BITSAT</li>
        <li>NDA</li>
        <li>Olympiads</li>
      </ul>

      <div style={{fontSize:'18px', fontWeight:'500', marginTop:'10px', marginBottom:'15px', paddingLeft:'15px'}}>
        Academic Levels :
      </div>
      <div style={{ fontSize:'16px', paddingLeft:'25px'}}>
        11th and 12th Grade (CBSE, ICSE, IB Board)
      </div>

      <div style={{fontSize:'18px', fontWeight:'500', marginTop:'10px', marginBottom:'10px', marginLeft:'15px'}} >Subjects :</div>
      <div style={{paddingLeft:'10px'}}>
      <div style={{fontSize:'18px', fontWeight:'500', marginTop:'10px', marginBottom:'5px', marginLeft:'15px'}} >Science Stream :– </div>

<ul style={{paddingLeft:'40px'}}>
      <li style={{fontSize:'16px', }}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>Core Subjects:</span> Physics, Chemistry, Biology, Mathematics
      </li>
      <li style={{fontSize:'16px'}}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>Additional Subjects:</span> Computer Science, Informatics Practices, English Core
      </li>
      <li style={{fontSize:'16px'}}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>Subject Combinations:</span> PCM (Physics, Chemistry, Mathematics), PCMB (Physics,
        Chemistry, Mathematics, Biology), PCB (Physics, Chemistry, Biology)
      </li>
      </ul>

      <h5 style={{fontSize:'18px', fontWeight:'500', marginTop:'10px', marginBottom:'5px', marginLeft:'15px' }}>Commerce Stream :– </h5>
      <ul style={{paddingLeft:'40px'}}>
      <li style={{fontSize:'16px'}}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>Core Subjects:</span> Business Studies, Accountancy, Economics
      </li>
      <li style={{fontSize:'16px'}}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>Additional Subjects:</span> Informatics Practices, Mathematics
      </li>
      </ul>

      <h5 style={{fontSize:'18px', fontWeight:'500', marginTop:'10px', marginBottom:'5px', marginLeft:'15px' }}>Humanities Stream :– </h5>
      <ul  style={{paddingLeft:'40px'}}>
      <li style={{fontSize:'16px'}}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>Core Subjects:</span> History, Geography, Political Science, Sociology
      </li>
      <li style={{fontSize:'16px'}}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>Additional Subjects:</span> Psychology, Philosophy, Art, Music, Physical Education,
        etc.
      </li>
      </ul>

      <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#C68863', marginTop:'20px', marginLeft:'-12px',lineHeight:'35px' }}
      >
        9th and 10th Grade (CBSE, ICSE, IB Board)
      </h2>
      <hr className='hr-tagg' style={{width:'80px', height:'5px', borderRadius:'10px', margin:'0px', marginLeft:'-12px' }} />


      <div style={{fontSize:'18px', fontWeight:'500', marginTop:'10px', marginBottom:'0px'}}>CBSE Board</div>
      <p style={{fontSize:'16px', paddingLeft:'15px'}}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>Core Subjects:</span> English, Hindi, Mathematics, Science, and Social Science
      </p>
      <p style={{fontSize:'16px', paddingLeft:'15px'}}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>Optional Subjects:</span>
      </p>
      <ul style={{ listStyleType: 'disc', paddingLeft:'40px'  }}>
        <li style={{fontSize:'16px'}}>Skill-based subject: (Information Technology or Computer Applications)</li>
        <li style={{fontSize:'16px'}}>Third Language: (foreign language like French or German)</li>
        <li style={{fontSize:'16px'}}>Other Electives: (Art Education, Health and Physical Education, or Work Experience)</li>
      </ul>

      <div style={{fontSize:'18px', fontWeight:'500', marginTop:'10px', marginBottom:'15px'}}>ICSE Board</div>
      <p style={{fontSize:'16px', paddingLeft:'15px'}}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>ICSE Class 9 Subjects:</span>
      </p>
      <ul style={{paddingLeft:'40px'}}>
      <li style={{fontSize:'16px'}}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>Compulsory:</span> English, Second Language, History and Civics, Geography
      </li>
      <li style={{fontSize:'16px'}}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>Optional:</span> Students choose any two of the following: Mathematics, Science
        (Physics, Chemistry, Biology), Economics, Commercial Studies, Modern Foreign Language,
        Classical Language
      </li>
      </ul>
      <p style={{fontSize:'16px'}}>
        <span style={{fontSize:'16px', fontWeight:'500', paddingLeft:'15px'}}>ICSE Class 10 Subjects:</span>
      </p>
      <ul style={{ listStyleType: 'disc', paddingLeft:'40px'  }}>

      <li style={{fontSize:'16px'}}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>Compulsory:</span> English, Second Language, History and Civics, Geography
      </li>
      <li style={{fontSize:'16px'}}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>Optional:</span> Students choose any two of the following: Mathematics, Science
        (Physics, Chemistry, Biology), Economics, Commercial Studies, Computer Science, etc.
      </li>
      <li style={{fontSize:'16px'}}>
        <span style={{fontSize:'16px', fontWeight:'500'}}>Additional:</span> Students may also choose an additional subject from a list of
        optional subjects like Home Science, Fashion Designing, etc.
      </li>

      </ul>

      <div style={{fontSize:'18px', fontWeight:'500', marginTop:'10px', marginBottom:'15px'}}>IB Board</div>
      <ul style={{ listStyleType: 'disc', fontSize:'16px', paddingLeft:'40px'}}>
        <li>English (Language & Literature)</li>
        <li>Second Language (like French / Spanish / Hindi)</li>
        <li>Maths</li>
        <li>Science (can be Biology, Chemistry, Physics or Integrated Science)</li>
        <li>Humanities (History / Geography / Economics)</li>
        <li>Arts (Visual Arts / Music / Drama)</li>
        <li>Design (Product Design / Digital Design)</li>
        <li>Physical & Health Education</li>
      </ul>

      </div>

      <h2
       style={{ fontSize: '24px', fontWeight: '600', color: '#C68863',lineHeight:'35px'}}
      >
        Kanha Online Classes
      </h2>
      <hr className='hr-tagg' style={{width:'80px', height:'5px', borderRadius:'10px', margin:'0px'}} />

      <p style={{ marginBottom: '15px',  fontSize:'16px', marginTop:'15px' }}>
        We provide: One Student, One Teacher, Expert Online Coaching for IIT-JEE (Main & Adv), NEET-UG,
        BITSAT, Olympiads, 12th, 11th (CBSE, ICSE, IB & other state board). Our experienced teachers
        will guide you to achieve academic success.
      </p>

      <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#C68863' ,lineHeight:'35px'}} >
        Best Managed Coaching System for Online Classes
      </h2>
      <hr className='hr-tagg' style={{width:'80px', height:'5px', borderRadius:'10px', margin:'0px'}} />

      <p style={{ marginBottom: '15px', fontSize:'16px', marginTop:'15px'}}>
        Experience the most efficient and effective online coaching system, designed to provide a
        structured and organised learning experience for students of all levels. Our system offers
        expert-led online classes, personalised learning plans, and comprehensive study material to
        ensure academic success in IIT-JEE (Main & Adv), NEET-UG, BITSAT, Olympiads, 12th, 11th (CBSE,
        ICSE, IB & other state board).
      </p>

      <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#C68863', lineHeight:'35px' }} >
        Our Features
      </h2>
      <hr className='hr-tagg' style={{width:'80px', height:'5px', borderRadius:'10px', margin:'0px'}} />

      <ul style={{ listStyleType: 'disc', fontSize:'16px', marginTop:'15px' }}>
        <li>
          <strong>Unlimited Mock Test:</strong> Kanha Home Tuitions Provide Unlimited Mock Test Each
          Student
        </li>
        <li>
          <strong>Experienced teachers:</strong> Tutors of Kanha Home Tuitions Well-Qualified and
          Experienced
        </li>
        <li>
          <strong>Personalized attention:</strong> One-On-One Attention and Personalized Guidance to
          help Students Reach Their Full Potential
        </li>
        <li>
          <strong>Flexible timings:</strong> Learn at your own Home with flexible tuition timings
        </li>
        <li>
          <strong>Regular progress reports:</strong> Regular progress reports to keep you updated on
          your child's academic growth.
        </li>
      </ul>
    </div>


        </div>

        <Footer />
    </>);
}

export default AboutUs;
